import { Component, OnInit } from '@angular/core';
import { RelatorioCertidoes } from "../../../model/relatorio-certidoes";
import { Router } from "@angular/router";
import { RelatoriosSrhService } from "../../../service/relatorios-srh/relatorios-srh.service";

@Component({
  selector: 'app-informacoes-funcionais',
  templateUrl: './informacoes-funcionais.component.html',
  styleUrls: ['./informacoes-funcionais.component.sass']
})
export class InformacoesFuncionaisComponent implements OnInit {
  componentType: number;
  itemSelect: any;
  relatorioCertidoes: RelatorioCertidoes[];
  private readonly _urlTipoRelatorio = "informacoes-funcionais/lista";

  constructor(private router: Router, private relatoriosSrhService: RelatoriosSrhService) { }

  ngOnInit(): void {
    this.router.navigate(['relatorios-srh/informacoes-funcionais']);
    this.relatoriosSrhService.getListaTiposRelatorios(this._urlTipoRelatorio).subscribe(resp => {
      this.relatorioCertidoes = resp;
    });
  }

  selectTipoComponent(value: any) {
    this.relatoriosSrhService.addTipoRelatorio(this.itemSelect);
    this.redirect();
  }

  redirect(): void {
    if(this.itemSelect){
      // this.router.navigate(['relatorios-srh/informacoes-funcionais'])
      this.router.navigate(['relatorios-srh/informacoes-funcionais/categorias'])
    }
  }

}
